import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import AssetList from './AssetList';
import { useQueryParams } from 'sharedHooks/useQuery';

import './style.scss';


const AssetListComponent = ({
    model: {
        assets,
        selectedAsset,
        selectedAssetCapability,
        generalFilterLoadingStatus,
        assetsLoadingStatus,
        //powertrainsLoadingStatus,
        selectedKPIType,
        filters,
        crossAssetAnalysisActiveTab,
        chartData,
        subscription,
        capabilityLoadingStatus
    },
    actions,
    onAssetClick
}) => {
    const { assetId: assetIdFromQuery } = useQueryParams();
    useEffect(() => {
        if (assetIdFromQuery && assets?.length) {
            if (!selectedAsset || selectedAsset.id?.toString() !== assetIdFromQuery?.toString()) {
                const assetObj = assets.find(asset => asset.id?.toString() === assetIdFromQuery?.toString());
                if (assetObj) {
                    actions.setSelectedAsset({ ...assetObj });
                }
            }
        }
    }, [assetIdFromQuery, assets]);
    return <div className='asset-list-container'>
        <LoadingStatusWrapper loadingStatus={[...generalFilterLoadingStatus, assetsLoadingStatus]}>
            <AssetList
                assets={assets}
                selectedAsset={selectedAsset}
                selectedAssetCapability={selectedAssetCapability}
                selectedKPIType={selectedKPIType}
                selectedPowertrain={filters.selectedPowertrain}
                onAssetClick={onAssetClick}
                getKPIsForKPIType={actions.getKPIsForKPIType}
                getTrendKPIsForAssetV2={actions.getTrendKPIsForAssetV2}
                setKpi={actions.setKpi}
                chartData={chartData}
                crossAssetAnalysisActiveTab={crossAssetAnalysisActiveTab}
                subscription={subscription}
                getSubscriptionInfo={actions.getSubscriptionInfo}
                capabilityLoadingStatus={capabilityLoadingStatus}
                getHistogramKPIsForAsset={actions.getHistogramKPIsForAsset}
                getScatterPlotKPIsForAsset={actions.getScatterPlotKPIsForAsset}
            />
        </LoadingStatusWrapper>
    </div>;
};

AssetListComponent.propTypes = {
    actions: PropTypes.shape({
        setActiveTabAction: PropTypes.func,
        setSearchboxFilterAction: PropTypes.func,
        setGatewayTypeFilterAction: PropTypes.func,
        setSelectedPowertrainID: PropTypes.func,
        setSelectedAsset: PropTypes.func,
        getKPIsForKPIType: PropTypes.func,
        getSubscriptionInfo: PropTypes.func,
        getTrendKPIsForAssetV2: PropTypes.func,
        setKpi: PropTypes.func,
        getHistogramKPIsForAsset: PropTypes.func,
    }),
    model: PropTypes.shape({
        powertrains: PropTypes.any,
        assets: PropTypes.any,
        selectedAsset: PropTypes.any,
        selectedAssetCapability: PropTypes.any,
        selectedKPIType: PropTypes.any,
        generalFilterLoadingStatus: PropTypes.array,
        assetsLoadingStatus: PropTypes.any,
        powertrainsLoadingStatus: PropTypes.any,
        filters: PropTypes.any,
        crossAssetAnalysisActiveTab: PropTypes.any,
        chartData: PropTypes.any,
        subscription: PropTypes.any,
        capabilityLoadingStatus: PropTypes.any,
    }),
    onAssetClick: PropTypes.func
};

export default AssetListComponent;
